import { memo, useState } from 'react';
import { NavigationNode } from '~/lib/data-contract';
import styles from './menu-area.module.css';
import { CollapseHeader, CollapsePanel } from '~/shared/components/accordion/accordion.component';
import { MenuItem } from './menu-item/menu-item.component';

type MenuAreaProps = {
    menu?: NavigationNode[];
};

export type MenuItemProps = {
    menuItem: NavigationNode;
    identifier?: string;
};

export const MenuArea = memo(({ menu }: MenuAreaProps) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    if (!menu) {
        return null;
    }

    return (
        <section className={styles.root}>
            {menu.map((menuItem, index) => (
                <div key={index} className={styles.menuWrapper}>
                    <CollapseHeader
                        as="h4"
                        onClick={() => setOpenIndex(openIndex === index ? null : index)}
                        isOpen={openIndex === index}
                        mobileOnly
                        className={styles.item}
                    >
                        {menuItem.link?.title}
                    </CollapseHeader>
                    <CollapsePanel isOpen={openIndex === index} mobileOnly className={styles.item}>
                        <MenuItem key={index} menuItem={menuItem} />
                    </CollapsePanel>
                </div>
            ))}
        </section>
    );
});
